const ExamData =  [
  {
    name: "CET",
    description:
      "Karnataka Common Entrance Test for admission into engineering, pharmacy, and medical courses across the state.",
    date: "April 18, 2026",
    time: "10:30 AM – 1:30 PM",
    place: "Across Karnataka",
  },
  {
    name: "COMEDK",
    description:
      "National-level entrance exam conducted for admission into private engineering colleges in Karnataka.",
    date: "May 10, 2026",
    time: "9:00 AM – 12:00 PM",
    place: "Pan India",
  },
  {
    name: "JEE MAINS",
    description:
      "India’s premier engineering entrance exam for admission to NITs, IIITs, and other centrally funded institutes.",
    date: "January 24, 2026",
    time: "Morning & Evening Shift",
    place: "All India",
  },
  {
    name: "NEET",
    description:
      "Mandatory national entrance exam for MBBS, BDS, AYUSH, and other medical courses in India.",
    date: "May 3, 2026",
    time: "2:00 PM – 5:20 PM",
    place: "Across India",
  },
  {
    name: "CLAT",
    description:
      "Common Law Admission Test for admission into undergraduate and postgraduate law programs in NLUs.",
    date: "December 7, 2025",
    time: "2:00 PM – 4:00 PM",
    place: "National Level",
  },
  {
    name: "CAT",
    description:
      "Highly competitive management entrance exam for admission into IIMs and top MBA colleges in India.",
    date: "November 29, 2025",
    time: "Multiple Slots",
    place: "Across India",
  },
  {
    name: "MAT",
    description:
      "Management Aptitude Test conducted for admission into MBA and PGDM programs across India.",
    date: "February 15, 2026",
    time: "10:00 AM – 12:30 PM",
    place: "Pan India",
  },
];

export default ExamData;